import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface FAQItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq-schema',
  template: `
    <div class="faq-section">
      <h2 class="faq-title">Frequently Asked Questions</h2>
      <div class="faq-list">
        <div class="faq-item" *ngFor="let faq of faqs">
          <h3 class="faq-question">{{ faq.question }}</h3>
          <p class="faq-answer">{{ faq.answer }}</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .faq-section {
      margin: 40px 0;
      padding: 30px;
      background: #f9f9f9;
      border-radius: 8px;
    }
    .faq-title {
      font-size: 28px;
      margin-bottom: 20px;
      color: #333;
    }
    .faq-item {
      margin-bottom: 20px;
      padding: 15px;
      background: white;
      border-radius: 5px;
      border-left: 4px solid #1976d2;
    }
    .faq-question {
      font-size: 18px;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 10px;
    }
    .faq-answer {
      font-size: 15px;
      color: #555;
      line-height: 1.6;
    }
  `]
})
export class FaqSchemaComponent implements OnInit {
  @Input() faqs: FAQItem[] = [];
  @Input() courseName: string = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.addFAQSchema();
  }

  addFAQSchema(): void {
    if (this.faqs.length === 0) return;

    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": this.faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
  }
}
